/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob1502Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob1502ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const whseJob1502FetchWhseJob1502Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob1502FetchWhseJob1502Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob1502AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const whseJob1502RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob1502SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const whseJob1502CreateWhseJob1502Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const whseJob1502CreateWhseJob1502Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob1502Types.WHSE_JOB1502_RESET_TIMESTAMP]: whseJob1502ResetTimestamp,
  [WhseJob1502Types.WHSE_JOB1502_FETCH_WHSE_JOB1502_LOADING]: whseJob1502FetchWhseJob1502Loading,
  [WhseJob1502Types.WHSE_JOB1502_FETCH_WHSE_JOB1502_SUCCESS]: whseJob1502FetchWhseJob1502Success,
  [WhseJob1502Types.WHSE_JOB1502_ADD_SELECTED_DOCUMENTS]: whseJob1502AddSelectedDocuments,
  [WhseJob1502Types.WHSE_JOB1502_REMOVE_SELECTED_DOCUMENTS]: whseJob1502RemoveSelectedDocuments,
  [WhseJob1502Types.WHSE_JOB1502_SET_WORKSPACE_VISIBLE]: whseJob1502SetWorkspaceVisible,
  [WhseJob1502Types.WHSE_JOB1502_CREATE_WHSE_JOB1502_LOADING]: whseJob1502CreateWhseJob1502Loading,
  [WhseJob1502Types.WHSE_JOB1502_CREATE_WHSE_JOB1502_SUCCESS]: whseJob1502CreateWhseJob1502Success
});
